export default "__VITE_ASSET___7SPQDqRdwtnKaclwn8Q4A__"